module.exports = __webpack_public_path__ + "img/MEDIA045.66d4aa42.jpg";